import {Controller} from '@hotwired/stimulus';
// eslint-disable-next-line import/no-named-as-default
import Swiper from 'swiper';
import {Pagination, Autoplay, Navigation} from 'swiper/modules';
// eslint-disable-next-line import/no-unresolved
import 'swiper/css';
// eslint-disable-next-line import/no-unresolved
import 'swiper/css/pagination';
// eslint-disable-next-line import/no-unresolved
import 'swiper/css/navigation';
import '../styles/carousel.css';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    swiper = null;

    static values = {
        options: Object,
        deleteInstance: {
            type: Boolean,
            default: true,
        },
        cleanStyles: {
            type: Boolean,
            default: true,
        },
    };

    connect() {
        this.swiper = new Swiper(this.element, {
            ...this.defaultOptions,
            ...this.optionsValue,
        });
    }

    init(swiper) {
        if (swiper.params.loop === true && swiper.slides.length === 2) {
            swiper.slideTo(0, 0, true);
        }
        swiper.el.classList.remove('opacity-0');
    }

    slideChangeTransitionEnd(swiper) {
        if (swiper.params.loop === true && swiper.slides.length === 2 && swiper.activeIndex === 1) {
            setTimeout(() => {
                swiper.slideTo(0, swiper.params.speed, true);
            }, swiper.autoplay.timeLeft);
        }
    }

    disconnect() {
        if (this.swiper !== null) {
            this.swiper.detachEvents();
            this.swiper.destroy(this.deleteInstanceValue, this.cleanStylesValue);
            this.swiper = null;
        }
    }

    stop() {
        this.swiper.autoplay.stop();
    }

    play() {
        this.swiper.autoplay.start();
    }

    get defaultOptions() {
        return {
            modules: [Pagination, Autoplay, Navigation],
            direction: 'horizontal',
            centeredSlides: true,
            navigation: {
                enabled: false,
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            autoplay: false,
            on: {
                init: this.init,
                slideChangeTransitionEnd: this.slideChangeTransitionEnd,
            },
        };
    }
}
